<template>
  <div class="music" @click="switchMusic">
    <img src="~@/assets/imgs/public/music-on.png" :class="{ rotate: on }">
  </div>
</template>

<script>
export default {
  name: 'music',

  data () {
    return {
      on: true
    }
  },

  methods: {
    switchMusic () {
      this.$bus.toggleMusic()
      this.on = !this.on
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/mixin.scss';

.music {
  position: fixed;
  padding: .3rem .28rem;
  width: .4rem;
  z-index: 900;
  top: 0;
  right: 0;
  font-size: 0;
  img {
    @include transition-fast;
    width: 100%;
    opacity: .4;
    &.rotate {
      opacity: 1;
    }
  }
}
</style>
